module.exports = __webpack_public_path__ + "img/nosotros.625a78f5.png";